var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lf"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src,"alt":""},on:{"click":_vm.viewImg}}),_c('preview-modal',{ref:"imageModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }